const SURVEYS_LIST = 'bfb/surveys/SURVEYS_LIST';
const SURVEYS_LIST_SUCCEEDED = 'bfb/surveys/SURVEYS_LIST_SUCCEEDED';
const SURVEYS_LIST_FAILED = 'bfb/surveys/SURVEYS_LIST_FAILED';

export default {
  SURVEYS_LIST_FAILED,
  SURVEYS_LIST_SUCCEEDED,
  SURVEYS_LIST,
};
